/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerFindOneQueryResponse, PromptsControllerFindOnePathParams, PromptsControllerFindOne401, PromptsControllerFindOne403, PromptsControllerFindOne404 } from "../../models/promptsController/PromptsControllerFindOne";

function getPromptsControllerFindOneUrl(id: PromptsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/prompts/${id}` as const }  
  return res
}

/**
 * @summary Get a prompt by ID
 * {@link /api/v1/prompts/:id}
 */
export async function promptsControllerFindOne(id: PromptsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptsControllerFindOneQueryResponse, ResponseErrorConfig<PromptsControllerFindOne401 | PromptsControllerFindOne403 | PromptsControllerFindOne404>, unknown>({ method : "GET", url : getPromptsControllerFindOneUrl(id).url.toString(), ... requestConfig })  
  return res.data
}